import useViewController from '../hooks/useViewController';
import { createContext } from 'react';

const ViewControllerContext = createContext<ReturnType<typeof useViewController>>(null);

export default ViewControllerContext;